//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonCard from "../CommonCard";
import Row from "../CommonRow";
import DateSwitch from "../DateSwitch";
import { mapState } from "vuex";

export default {
  components: { CommonCard, DateSwitch, Row },
  data() {
    return {
      data: [50, 30],
      active: 2,
    };
  },
  computed: {
    ...mapState(["dateList"]),
    filterData() {
      // 把最大的用100%展示，其他的依照最大的算百分比
      let list = this.data.map((v) => Math.abs(v));
      let max = Math.max(...list);
      if (max > 100) {
        return list.map((v) => (v / max) * 100 + "%");
      } else {
        return list.map((v) => (v / 100) * 100 + "%");
      }
    },
  },
};
